interface iDaysPopupCoupon {
  first_time_date?: number
}
export const popupCouponStore = defineStore('popupCoupon', {
  state: () => ({
    bellaTimerPopupCoupon: {} as iDaysPopupCoupon
  }),
  actions: {
    async setPopupCouponParams(payload: object) {
      this.bellaTimerPopupCoupon = payload
    },
  },
  persist: {
    key: 'bellaTimerPopupCoupon',
    storage: piniaPluginPersistedstate.localStorage(),
  }
})
